// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"Slider_sliderWrapper__lnEdj","label":"Slider_label__l6vXG"};